import { UpdateClientService } from '../services'

export default (client) => {
	return new Promise(async (resolve, reject) => {
		await UpdateClientService.save(client)
			.then(response => resolve(response))
			.catch(err => reject({error: true}))
	})
}
